import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import { SortTableBy, TableColumn, TableOrder } from "./types";
import { createStyles, Theme, withStyles } from "@material-ui/core";

type Props = {
  columns: TableColumn[];
  selectable: boolean;
  onSelectAllClick: (event: any) => void;
  numSelected: number;
  order: TableOrder;
  orderBy: SortTableBy;
  rowCount: number;
  onRequestSort: (property: SortTableBy) => void;
};

type State = {};

const styles = (theme: Theme) => createStyles({});

class TableHeader extends React.Component<Props, State> {
  createSortHandler: (property: SortTableBy) => (event: any) => void;

  constructor(props: Props) {
    super(props);
    this.createSortHandler = (property: SortTableBy) => (event: any) => {
      this.props.onRequestSort(property);
    };
  }

  renderHeader(id: string, label: string, parentId?: string) {
    const { order, orderBy } = this.props;
    return (
      <TableCell key={id} sortDirection={orderBy.id === id ? order : false}>
        <Tooltip title="Sort" placement={"bottom-start"} enterDelay={300}>
          <TableSortLabel
            active={orderBy.id === id}
            data-test-control={id}
            direction={order}
            onClick={this.createSortHandler({ id, parentId })}
          >
            {label}
          </TableSortLabel>
        </Tooltip>
      </TableCell>
    );
  }

  render() {
    const {
      columns,
      selectable,
      onSelectAllClick,
      numSelected,
      rowCount
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          {selectable && (
            <TableCell padding="checkbox">
              <Checkbox
                checked={numSelected === rowCount}
                indeterminate={numSelected > 0 && numSelected < rowCount}
                inputProps={{
                  "aria-label": "Select row"
                }}
                onChange={onSelectAllClick}
              />
            </TableCell>
          )}
          {columns.map(column => {
            if (column.children && column.children.length > 0) {
              return column.children.map(child =>
                this.renderHeader(child.id, child.label, column.id)
              );
            }
            return this.renderHeader(column.id, column.label);
          })}
        </TableRow>
      </TableHead>
    );
  }
}

export default withStyles(styles)(TableHeader);
